var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$vuetify.lang.t('$vuetify.create_position')))]),_c('PositionForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }